<template>
  <AppPageContainer :custom="1600" :min-height="0">
    <AppPageHeader design="new" title="AI analysis" compact />
    <AppTabs design="new" refined weight="medium" :tabs="tabs" value="first-reply" />
    <FirstReplyWorkspace />
  </AppPageContainer>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import FirstReplyWorkspace from './FirstReplyWorkspace'

export default {
  name: 'TechSupportAiAnalysis',
  components: { AppTabs, FirstReplyWorkspace },
  data: () => ({ tabs: [{ value: 'first-reply', label: 'Trengo first reply' }] })
}
</script>
